export default "__VITE_ASSET__0XpwyN4q__"